import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/buyVip/close.png'
import _imports_1 from '@/assets/images/buyVip/buy-vip-select.png'


const _withScopeId = n => (_pushScopeId("data-v-7e7b635a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "buy-single-paper-dia" }
const _hoisted_2 = {
  key: 0,
  class: "el-dialog__body"
}
const _hoisted_3 = { class: "dia-title" }
const _hoisted_4 = { class: "dia-des" }
const _hoisted_5 = { class: "buy-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "buy-type-common-text" }, "单卷购买：", -1))
const _hoisted_7 = { class: "buy-paper-price" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "¥", -1))
const _hoisted_9 = {
  key: 0,
  class: "buy-vip"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "buy-type-common-text" }, "开通会员：", -1))
const _hoisted_11 = { class: "buy-vip-info-box" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "buy-vip-info-label" }, "试卷宝会员", -1))
const _hoisted_13 = { class: "buy-vip-price-box" }
const _hoisted_14 = { class: "buy-vip-price" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "¥", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "buy-vip-use-discounts" }, "半年卡（20套/月）", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "buy-vip-des" }, "开通会员单卷低至0.4元", -1))
const _hoisted_18 = { class: "buy-btn" }

import { useStore } from "vuex";
import { Ref, ref, computed, reactive, onMounted, toRefs, watch } from "vue";
import { responseToCamelCase } from "@/utils/utils.js";
import { rePlayLoad } from "../vip/utils.js";
import { getVipDetail } from "@/api/vip";

import PayStatusDialog from "@/components/buyVip/PayStatusDialog.vue";
import BuyPaperSuccess from "@/components/buyVip/BuyPaperSuccess.vue";
import PayBtn from "@/components/vip/PayBtn.vue";
import {
  clickPay,
  showPcpaperdetailPaypopupBlank,
} from "@/trace/xesTackBuySinglePaper";

// 关闭弹窗事件

export default /*#__PURE__*/_defineComponent({
  __name: 'BuySinglePaper',
  props: {
  showBuyPaper: {
    type: Boolean,
    default: false,
  },
  // 弹窗展示的标题 “下载试卷”，“详解版”、“答案版”
  title: {
    type: String,
    default: "",
  },
  // 是否是会员 1:是会员弹窗说明没有次数了 0:说明不是会员（需显示会购买员引导）
  isVip: {
    type: Number,
    default: 0,
  },
  // 单卷购买的价格
  paperUnitPrice: {
    type: Number,
    default: 0,
  },
  // 详情页的试卷信息
  paperData: {
    type: Object,
    default: () => ({
      name: "",
      id: "",
    }),
  },
  // 下单的参数
  payload: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ["onCloseSinglePaperDia"],
  setup(__props, { emit }) {

const props = __props;

/**
 * @description:单卷购买弹窗
 *
 */
let store = useStore();



const userInfo = computed(() => store.state.user.userInfo);



let payStatusVisible: Ref<number> = ref(0); // 是否弹出支付状态弹窗
let selectBuyVip: Ref<boolean> = ref(false); // 是否勾选开通会员
let paySuccess: Ref<boolean> = ref(false); // 是否支付成功
let currentItem: Ref<object> = ref(null); // 半年会员需要展示的数据
let loading: Ref<boolean> = ref(false); // 是否支付成功
const vipPlayLoad = ref({}); // vip购买需要传的参数
const paySuccessInfo = ref({}); // vip购买需要传的参数

const sectionOpacity = ref(1);

const xesTrackInfo = computed(() => {
  return {
    is_login: userInfo.value ? "是" : "否", //是否登录
    is_vip: props.isVip === 1 ? "是" : "否", //是否会员
    popup_isvip: currentItem.value ? "是" : "否", // 购买弹窗状态（只有单卷购买：否，两个都有：是）
  };
});

watch(props, (prop) => {
  if (prop.showBuyPaper) {
    getVipDetailData();
    showPcpaperdetailPaypopupBlank({
      ...xesTrackInfo.value,
    });
  }
});
// 改变勾选开通会员
const changeSelectBuyVip = () => {
  selectBuyVip.value = !selectBuyVip.value;
};

// 关闭弹窗 
const closeDialog = () => {
  selectBuyVip.value = false;
  // type: 1 没有支付成功关闭弹窗 2: 支付成功后的关闭
  emit("onCloseSinglePaperDia", paySuccess.value ? 2 : 1);
  store.commit("setPreBrowseInfo", null);
};

// 提交支付
const submitPay = () => {
  clickPay({
    ...xesTrackInfo.value,
    check_vip: selectBuyVip.value ? "是" : "否", //是否勾选会员
  });
  // 存上次浏览记录
  store.commit("setPreBrowseInfo", props.paperData);
  loading.value = true;
};

// 支付成功回调结果
const paySuccessCall = (res) => {
  // 判断是否是会员购买
  paySuccess.value = true;
  // goodstype 1:会员 2:单卷
  paySuccessInfo.value = res;
  loading.value = false;
};

// 支付失败回调结果
const payFailCall = (res) => {
  loading.value = false;
};

// 订单创建失败
const creatOrderFail = () => {
  loading.value = false;
  closeDialog();
};

// 获取会员sku信息
const getVipDetailData = () => {
  getVipDetail({
    is_whitelist: 0,
    type: "goods",
    vip_type: 2,
  })
    .then((res) => {
      if (res?.code) {
        return;
      }
      const groupList = res?.data?.goods?.group_list || [];
      const list = groupList
        .filter((item) => item?.version === 1 && item?.type === 2)
        .map((item) => {
          const skuList = item?.sku_list || [];
          const skuListFilter = skuList
            .filter((skuItem) => skuItem?.is_auto_renew === 0)
            .slice(0, 3);
          return skuListFilter;
        })
        .flat();

      const halfAYearList = list.filter((item) => {
        // 按照180为标识取半年卡
        return item.auth_day === 180;
      });

      const vipList = responseToCamelCase(halfAYearList);
      const item = vipList[0];
      currentItem.value = item;
      const playLoad = rePlayLoad(item);
      vipPlayLoad.value = playLoad;
    })
    .catch((err) => {
      console.log(err);
    });
};
const showNativePay = () => {
  sectionOpacity.value = 0;
};
const paymentResultQuery = () => {
  sectionOpacity.value = 1;
};

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (__props.showBuyPaper)
    ? _withDirectives((_openBlock(), _createElementBlock("section", {
        key: 0,
        "align-center": "",
        "show-close": false,
        "close-on-click-modal": false,
        "element-loading-background": "rgba(0, 0, 0, 0)",
        style: _normalizeStyle({ opacity: sectionOpacity.value }),
        class: "mask"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", { class: "dialog-header" }, [
            _createElementVNode("img", {
              class: "close",
              src: _imports_0,
              onClick: closeDialog
            })
          ]),
          (!_unref(paySuccess))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1),
                _createElementVNode("div", _hoisted_4, _toDisplayString(__props.isVip
              ? "您周期内的下载次数已用尽，请购买后查看~"
              : "该文档为付费文档，请购买或开通会员后下载"), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['buy-paper', { 'is-vip': __props.isVip }])
                  }, [
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("span", null, _toDisplayString(__props.paperUnitPrice / 100), 1)
                    ])
                  ], 2),
                  (!__props.isVip && _unref(currentItem))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _hoisted_10,
                        (_unref(selectBuyVip))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _imports_1,
                              alt: "",
                              onClick: changeSelectBuyVip,
                              class: "select-common"
                            }))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "select-common ring",
                              onClick: changeSelectBuyVip
                            })),
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _hoisted_15,
                              _createElementVNode("span", null, _toDisplayString(_unref(currentItem)?.price / 100), 1)
                            ]),
                            _hoisted_16
                          ]),
                          _hoisted_17
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(PayBtn, {
                      paperData: { ...__props.paperData, ...{ paperUnitPrice: __props.paperUnitPrice } },
                      playLoad: _unref(selectBuyVip) ? vipPlayLoad.value : __props.payload,
                      goodsType: _unref(selectBuyVip) ? 1 : 2,
                      onCreatFail: creatOrderFail,
                      onHandlePay: submitPay,
                      onShowNativePay: showNativePay,
                      onPaymentResultQuery: paymentResultQuery,
                      onPaySuccess: paySuccessCall,
                      onPayFail: payFailCall
                    }, {
                      text: _withCtx(() => [
                        _createTextVNode("立即支付")
                      ]),
                      _: 1
                    }, 8, ["paperData", "playLoad", "goodsType"])
                  ])
                ])
              ]))
            : (_openBlock(), _createBlock(BuyPaperSuccess, {
                key: 1,
                paySuccessInfo: paySuccessInfo.value,
                onToCloseSinglePaperDia: closeDialog
              }, null, 8, ["paySuccessInfo"]))
        ]),
        _createVNode(PayStatusDialog, { showPayStatus: _unref(payStatusVisible) }, null, 8, ["showPayStatus"])
      ], 4)), [
        [_directive_loading, _unref(loading)]
      ])
    : _createCommentVNode("", true)
}
}

})